import { Text, IconButton, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Actionsheet, Box, Popover, useDisclose } from 'native-base';
import React, { useState } from 'react';

import { CustomItemTagObject } from '../../../../../store/ProducManagement/types';

import { ItemTagContent } from './content';
import { ItemTagTriggerButton } from './triggerButton';

export interface ItemTagProps {
  data: CustomItemTagObject[];
}

export const ItemTag: React.FC<ItemTagProps> = ({ data }) => {
  const { isOpen, onOpen, onClose } = useDisclose();
  const isDesktop = useBreakpointValue({ base: false, lg: true });

  const [isOpenPopover, setIsOpenPopover] = useState(false);

  const handleActivePopover = () => setIsOpenPopover(true);

  const tagContentProps = {
    data,
  };

  if (isDesktop) {
    return (
      <Popover
        useRNModal
        trigger={(triggerProps) => (
          <ItemTagTriggerButton
            onOpen={handleActivePopover}
            triggerProps={triggerProps}
            tags={data}
          />
        )}
        isOpen={isOpenPopover}
        onClose={() => setIsOpenPopover((state) => !state)}>
        <Popover.Content maxW="270px" shadow={4} p={Spacing['stack.xxxs']} bg="neutral.white">
          <ItemTagContent data={data} />
        </Popover.Content>
      </Popover>
    );
  }

  return (
    <Box>
      <ItemTagTriggerButton onOpen={onOpen} tags={data} />
      <Actionsheet useRNModal isOpen={isOpen} onClose={onClose} size="full">
        <Actionsheet.Content _dragIndicator={{ bg: 'neutral.lightest' }}>
          <VStack space={Spacing['stack.xxxs']} w="full" p={Spacing['stack.xxxs']}>
            <HStack alignItems="center" justifyContent="space-between">
              <Text variant="semibold" fontSize={Typography['fontsize.lg']} color="neutral.black">
                Produtos bloqueados
              </Text>
              <IconButton
                icon="Close"
                iconSize="xxs"
                iconColor={Color['neutral.medium']}
                onPress={onClose}
                testId="icon-button-close-action-sheet"
              />
            </HStack>
            <ItemTagContent {...tagContentProps} />
          </VStack>
        </Actionsheet.Content>
      </Actionsheet>
    </Box>
  );
};
